class AddonProductModal {
  constructor() {
    this.modalOpener = document.getElementById("AddonProductModalOpener");
    if (!this.modalOpener) return;
    this.productForm = document.querySelector("product-form");
    this.cart = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
    window.latestCartData = this.cart.latestCartData;
    this.currentCity = null;
    this.isSubmitting = false; // Prevent multiple rapid submissions
    this.init();
    this.data = {};
    this.data.items = [];
  }

  /**
   * Convert city name to English format
   * @param {string} cityName - The city name (could be Arabic or English)
   * @returns {string} - English city name
   */
  convertToEnglishCity(cityName) {
    if (!cityName || cityName === 'null') return 'Riyadh';
    
    // If already English, return as is
    const englishCities = ['Riyadh', 'Jeddah', 'Al Khobar', 'Dammam', 'Dhahran', 'Jubail','Qatif','Meccah'];
    if (englishCities.includes(cityName)) {
      return cityName;
    }
    
    // Convert Arabic to English
    const arabicToEnglish = {
      'الرياض': 'Riyadh',
      'جدة': 'Jeddah',
      'الخبر': 'Al Khobar',
      'الدمام': 'Dammam',
      'الظهران': 'Dhahran',
      'الجبيل': 'Jubail',
      'القطيف': 'Qatif',
      'المدينة':'Madinah',
      'مكه':'Meccah'

    };
    
    return arabicToEnglish[cityName] || cityName;
  }

  init() {
    // Get initial city
    this.currentCity = localStorage.getItem('city_value') || localStorage.getItem('city') || 'Riyadh';
    
    // Listen to the AddonProductModalOpener button
    this.modalOpener.addEventListener("click", (event) => {
      event.preventDefault();
      const modal = document.getElementById('lc-confirmation-modal');
      const yesBtn = document.getElementById('lc-confirm-yes');
      if (!modal || !yesBtn) {
        this.handleAddToCartClick();
      }
      else{
        if (modal) {
          modal.classList.remove('hidden');
          modal.dataset.trigger = "";
          document.body.appendChild(modal);
          document.body.classList.add('lc-confirmation-modal-active');
          modal.dataset.trigger = "main-atc";
        }
         if (yesBtn) {
            if (!yesBtn.dataset.bound) {
              yesBtn.dataset.bound = "true";
              yesBtn.addEventListener('click', (e) => {
                document.body.classList.remove('lc-confirmation-modal-active');
                window.lcWarningActive = true;
                modal.classList.add('hidden');
                this.handleAddToCartClick();
              });
            }
          
         }

      }

      //this.handleAddToCartClick();
    });

    // Also listen to the main product form submission
    // But only prevent default if we're on PDP and addons exist
    // Otherwise let the form submit normally
    if (this.productForm && this.productForm.form) {
      this.productForm.form.addEventListener("submit", (event) => {
        // Don't intercept if we're already processing (to avoid recursion)
        if (this.isProcessingAddToCart) {
          return;
        }
        
        const isPDP = window.location.pathname.includes('/products/');
        const hasAddons = Array.isArray(ADDONS) && ADDONS.length > 0;
        
        // Only intercept on PDP when addons exist
        if (isPDP && hasAddons) {
          event.preventDefault();
          this.handleAddToCartClick();
        }
        // Otherwise let the form submit normally (for quick add, etc.)
      });
    }

    // Setup city change listeners
    this.setupCityChangeListener();
    
    // Listen for variant changes to update price in addon modal
    this.setupVariantChangeListener();
  }

  setupCityChangeListener() {
    // Listen for city changes from header dropdown
    document.addEventListener('city-changed', (event) => {
      const newCity = event.detail.value || event.detail.textValue;
      if (newCity !== this.currentCity) {
        this.currentCity = newCity;
        // Refresh modal if it's open
        if (this.modal && this.modalObject) {
          this.refreshModalContent();
        }
      }
    });

    // Also watch localStorage changes
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = (key, value) => {
      originalSetItem.call(localStorage, key, value);
      
      if ((key === 'city' || key === 'city_value') && value !== this.currentCity) {
        this.currentCity = value;
        // Refresh modal if it's open
        if (this.modal && this.modalObject) {
          this.refreshModalContent();
        }
      }
    };

    // Listen for other city-related events
    document.addEventListener('location-changed', (event) => {
      if (event.detail && event.detail.city && event.detail.city !== this.currentCity) {
        this.currentCity = event.detail.city;
        if (this.modal && this.modalObject) {
          this.refreshModalContent();
        }
      }
    });

    document.addEventListener('city-updated', (event) => {
      if (event.detail && event.detail.city && event.detail.city !== this.currentCity) {
        this.currentCity = event.detail.city;
        if (this.modal && this.modalObject) {
          this.refreshModalContent();
        }
      }
    });
  }

  setupVariantChangeListener() {
    // Listen for variant changes to update addon modal price
    document.addEventListener(PUB_SUB_EVENTS.variantChange, (event) => {
      // Update the total cart price in addon modal if it's open
      if (this.modal && this.addonTotalCart) {
        this.updateTotalCart();
      }
    });
  }

  refreshModalContent() {
    if (this.modal && this.productGrid) {
      // Re-render the grid with city filtering
      this.renderGrid();
    }
  }

  handleAddToCartClick(skipAddonCheck = false) {
    // Prevent infinite recursion
    if (this.isProcessingAddToCart) {
      return;
    }
    this.isProcessingAddToCart = true;

    // Check if main product requires image upload
    if (this.productForm?.hasImageUpload && this.productForm?.isImageUploadMandetory && this.productForm?.getStringAttribute(this.productForm?.productInfo, "data-image-urls", "") === "") {
      this.productForm?.handleErrorMessage(this.productForm?.imageUploadErrorMessage);
      this.isProcessingAddToCart = false;
      return;
    }

    if (this.productForm?.hasProductMessage && this.productForm?.isProductMessageMandetory && this.productForm?.getStringAttribute(this.productForm, "data-message", "") === "") {
      this.productForm?.handleErrorMessage(this.productForm?.productMessageErrorMessage);
      this.isProcessingAddToCart = false;
      return;
    }

    // Check if ADDONS exists and has data (unless we're skipping the check)
    if (!skipAddonCheck) {
      if (!Array.isArray(ADDONS) || ADDONS.length <= 0) {
        // No addons - submit form normally (will open drawer)
        this.isProcessingAddToCart = false;
        let submitEvent = new Event("submit", { bubbles: true, cancelable: true });
        this.productForm.form.dispatchEvent(submitEvent);
        return;
      }

      // Check if there are any available addon products after city filtering
      const hasAvailableAddonProducts = this.checkForAvailableAddonProducts();
      
      if (!hasAvailableAddonProducts) {
        // No addon products available for current city, directly add to cart
        this.isProcessingAddToCart = false;
        let submitEvent = new Event("submit", { bubbles: true, cancelable: true });
        this.productForm.form.dispatchEvent(submitEvent);
        return;
      }
    }

    // On PDP with addons: add main product to cart first (without opening drawer), then open modal
    // Check if we're on PDP
    const isPDP = window.location.pathname.includes('/products/');
    
    if (isPDP && !skipAddonCheck) {
      // Set a flag to indicate we're adding to cart from addon modal flow
      // This will be checked in product-form.js to determine if drawer should open
      if (this.productForm) {
        this.productForm.dataset.addonModalFlow = 'true';
      }
      
      // Add main product to cart first (will update cart icon but not open drawer)
      // The product-form.js will handle not opening the drawer when addons exist
      // Call onSubmitHandler directly to bypass form submit listener
      const syntheticEvent = new Event("submit", { bubbles: true, cancelable: true });
      this.productForm.onSubmitHandler.call(this.productForm, syntheticEvent);
      
      // Wait a moment for cart to update, then open modal
      setTimeout(() => {
        // Clear the flag
        if (this.productForm) {
          this.productForm.dataset.addonModalFlow = 'false';
        }
        
        this.isProcessingAddToCart = false;
        // Show loader before opening modal
        this.showLoader();
        
        // Simulate loading time
        setTimeout(() => {
          this.hideLoader();
          this.openModal();
          this.attachEventListeners();
        }, 500);
      }, 300);
    } else {
      // Not on PDP - normal flow
      this.isProcessingAddToCart = false;
      // Show loader before opening modal
      this.showLoader();

      // Simulate loading time (you can adjust this or remove if not needed)
      setTimeout(() => {
        this.hideLoader();
        this.openModal();
        this.attachEventListeners();
      }, 1000);
    }
  }

  /**
   * Check if there are any available addon products for the current city
   * @returns {boolean} - True if there are available addon products, false otherwise
   */
  checkForAvailableAddonProducts() {
    if (!Array.isArray(ADDONS) || ADDONS.length === 0) {
      console.log('AddonProductModal: No ADDONS data available');
      return false;
    }

    let totalProducts = 0;
    let availableProducts = 0;

    // Check each category for available products
    for (const category of ADDONS) {
      if (category.products && Array.isArray(category.products)) {
        totalProducts += category.products.length;
        for (const product of category.products) {
          if (this.isProductAvailableInCity(product)) {
            availableProducts++;
            return true; // Found at least one available product
          }
        }
      }
    }

    return false; // No available products found
  }

  // Calculate total quantity of selected add-ons
  calculateTotalQuantity() {
    const total = this.data.items.reduce((total, item) => {
      const quantity = Math.max(0, parseInt(item.quantity) || 0);
      return total + quantity;
    }, 0);
    
    return total;
  }

  // Calculate total price of selected add-ons
  calculateTotalPrice() {
    return this.data.items.reduce((total, item) => {
      const price = parseFloat(item.properties?._price) || 0;
      const quantity = Math.max(0, parseInt(item.quantity) || 0);
      return total + price * quantity;
    }, 0);
  }

  // Update the add-on summary display
  updateAddonSummary() {
    const totalQuantity = this.calculateTotalQuantity();
    const totalPrice = this.calculateTotalPrice();

    if (this.addonSummaryQuantity) {
      this.addonSummaryQuantity.textContent = totalQuantity;
    }

    if (this.addonSummaryPrice) {
      this.addonSummaryPrice.textContent = totalPrice.toFixed(2);
      this.addonSummaryPrice.setAttribute("data-price-to-convert", totalPrice);
      // Trigger currency conversion if available
      if (typeof initialCurrencyChange === "function") initialCurrencyChange();
    }

    // Update total cart value (parent product + addons)
    this.updateTotalCart();
  }

  // Update total cart value (parent product + addons)
  updateTotalCart() {
    if (this.addonTotalCart) {
      const parentProductPrice = this.getParentProductPrice();
      const addonsTotal = this.calculateTotalPrice();
      let totalCartValue = parentProductPrice + addonsTotal;

      // Ensure we never have a negative total
      totalCartValue = Math.max(0, totalCartValue);

      // Ensure we always have a valid price
      const displayPrice = isNaN(totalCartValue) ? parentProductPrice : totalCartValue;

      this.addonTotalCart.textContent = `QAR ${displayPrice.toFixed(2)}`;
      this.addonTotalCart.setAttribute("data-price-to-convert", displayPrice);

      // Trigger currency conversion if available
      if (typeof initialCurrencyChange === "function") initialCurrencyChange();
    }
  }

  // Get initial cart total from cart data
  getInitialCartTotal() {
    if (window.latestCartData && window.latestCartData.total_price) {
      return parseFloat(window.latestCartData.total_price) / 100; // Convert from cents
    }
    return 0;
  }

  // Get parent product price from product form
  getParentProductPrice() {
    if (this.productForm && this.productForm.dataset.productPrice) {
      const price = parseFloat(this.productForm.dataset.productPrice); // Price is already in correct format
      return isNaN(price) ? 0 : price;
    }
    return 0;
  }

  // Safely update summary elements if they exist
  safeUpdateSummary() {
    if (this.addonSummaryQuantity && this.addonSummaryPrice) {
      this.updateAddonSummary();
    } else {
      // Try to re-initialize summary elements if they don't exist
      this.addonSummaryQuantity = this.modal?.querySelector("#addonSummaryQuantity");
      this.addonSummaryPrice = this.modal?.querySelector("#addonSummaryPrice");
      this.addonTotalCart = this.modal?.querySelector("#addonTotalCart");
      if (this.addonSummaryQuantity && this.addonSummaryPrice) {
        this.updateAddonSummary();
      }
    }
  }

  // Remove item from add-ons and update summary
  removeAddonItem(variantId) {
    // Remove the item completely
    this.data.items = this.data.items.filter((item) => item.id !== variantId);

    // Reset any negative quantities in the UI
    const productCard = document.querySelector(`.addon-button[data-variant-id="${variantId}"]`)?.closest(".card-wrapper");
    if (productCard) {
      const quantityInput = productCard.querySelector(".addon-modal__content .quantity__input");
      if (quantityInput) {
        quantityInput.value = 1; // Reset to default quantity
      }
    }

    this.updateAddonSummary();
  }

  createAddonGrid() {
    this.data = {};
    this.data.items = [];
    let tabs = "";

    ADDONS.forEach((category, index) => {
      tabs += `<button data-id="${category.id}" class="btn btn--primary ${index === 0 ? "active" : ""}">${category.name}</button>`;
    });

    return `
      <div class="addon-modal">
        <div class="close-button modal-close right-12 cursor-pointer addonClose" x-modal-close>
          <span class="visually-hidden">Close</span>
          <div class="addon-close-button">
            <span class="addon-close-x">×</span>
          </div>
        </div>
        <div class="addon-modal__content">
          <h3 class="addon-modal__title">${Shopify.locale == "en" ? "Make it more special" : "اجعلها أكثر خصوصية"}</h3>
          
          <div class="addon-modal__tab-wrapper scrollbar-hidden">
            <div class="addon-modal__tab-container">${tabs}</div>
          </div>
          <ul class="grid product-grid grid--6-col-desktop grid--2-col-tablet-down"></ul>
          <div class="addon-modal__bottom-tab-container">
            <!-- Add-on Summary Section (Left Side) -->
            <div class="addon-summary-section">
              <div class="addon-summary-item">
                <span class="addon-summary-label">${Shopify.locale == "en" ? "Added Items =  " : "العناصر المضافة = "}</span>
                <span class="addon-summary-value" id="addonSummaryQuantity">0</span>
              </div>
              <div class="addon-summary-item">
                <span class="addon-summary-label">${Shopify.locale == "en" ? "Total Added Items =  " : "إجمالي العناصر المضافة = "}</span>
                <span class="addon-summary-value" id="addonSummaryPrice" data-price-to-convert="0">0.00</span>
              </div>
            </div>
            
            <!-- Right Side - Continue to Cart Button and Total Cart in Flex Container -->
            <div class="addon-modal__right-section">
              <div class="addon-modal__button-cart-container">
              <div class="addon-modal__total-cart-container">
                <div class="addon-modal__total-cart">
                  <span class="addon-summary-label">${Shopify.locale == "en" ? "Total Cart = " : "إجمالي السلة = "}</span>
                  <span class="addon-summary-value" id="addonTotalCart" data-price-to-convert="${this.getParentProductPrice()}">${(this.getParentProductPrice() || 0).toFixed(2)}</span>
                </div>
                </div>
                <button id="continueToCart" class="btn btn--primary">
                  <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg>
                  <span class="hide-on-loading">${Shopify.locale == "en" ? "Proceed to Cart" : "الاستمرار في سلة التسوق"}</span>
                </button>
              </div>
              <p id="addOnPrice" class="fw-500">
                <span id="addOnPriceText"></span>
                <span id="addOnPriceMoney"></span>
              </p>
              <p id="errorMessage" class="error-message fw-500"></p>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  renderGrid(categoryId = null) {
    
    
    // Check if ADDONS exists and has data
    if (!ADDONS || !Array.isArray(ADDONS) || ADDONS.length === 0) {
      console.error('AddonProductModal: No ADDONS data available');
      this.productGrid.innerHTML = '<li class="grid__item">No addon products available</li>';
      return;
    }
    
    let gridHTML = "";
    if (!categoryId) {
      ADDONS.forEach((category, index) => {
        if (index === 0) {
          // Filter products by city availability only
          const availableProducts = category.products.filter((product) => {
            return this.isProductAvailableInCity(product);
          });
          
          gridHTML += `${availableProducts.map((product) => `<li class="grid__item scroll-trigger animate--slide-in" style="--animation-order: ${index};">${this.decodeBase64HTML(product.html)}</li>`).join("")}`;
        }
      });
    } else {
      let filteredObject = ADDONS.find((object) => object.id === categoryId);
      if (filteredObject) {
        // Filter products by city availability only
        const availableProducts = filteredObject.products.filter((product) => {
          return this.isProductAvailableInCity(product);
        });
        
        gridHTML += `${availableProducts.map((product, index) => `<li class="grid__item scroll-trigger animate--slide-in" style="--animation-order: ${index};">${this.decodeBase64HTML(product.html)}</li>`).join("")}`;
      }
    }
    
    this.productGrid.innerHTML = gridHTML;
    this.productGrid.scrollTop = 0;
    this.addToCartEventListener();
    this.setSelectedStateOnProducts();
    this.continueToCartEventListener();
    this.preventCardClicks(); // Add this to prevent card clicks
    this.ensureAddonButtonsShowATC(); // Ensure all addon buttons show "Add to Cart"
    if (typeof initialCurrencyChange === "function") initialCurrencyChange();

    this.tabsWrapper = this.modal.querySelector(".addon-modal__tab-wrapper");
    if (!this.tabsWrapper) return;
    this.tabsWrapper.addEventListener(
      "mousewheel",
      function (e) {
        this.scrollLeft -= e.wheelDelta;
        e.preventDefault();
      },
      false
    );
  }

  decodeBase64HTML(string) {
    try {
      return decodeURIComponent(
        atob(string)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
    } catch (e) {
      console.error(`🚀 || product-addon.js:96 || AddonProductModal || decodeBase64HTML || Error decoding base64 HTML:`, e);
      return "";
    }
  }

  /**
   * Check if a product is available in the current city
   * @param {Object} product - The product object from ADDONS
   * @returns {boolean} - True if product is available in current city
   */
  isProductAvailableInCity(product) {
    // If no current city set, show all products
    if (!this.currentCity) {
      return true;
    }

    // Get city data from the product object
    const cityData = product.city_data;
    
    // If no city data, show everywhere (this is the most common case)
    if (!cityData || cityData.trim() === '') {
      return true;
    }

    // Parse city data - handle different formats
    let listOfCities = [];
    
    // First try to parse as JSON
    try {
      listOfCities = JSON.parse(cityData);
    } catch (e) {
      // If not JSON, try different string formats
      if (typeof cityData === 'string') {
        // Try comma-separated first
        if (cityData.includes(',')) {
          listOfCities = cityData.split(',').map(city => city.trim());
        } else {
          // Handle concatenated city names (like "DammamJeddahAl-KhobarDhahranRiyadhMeccah")
          // This is a more complex case - we need to split by known city boundaries
          const knownCities = [
            'Dammam', 'Jeddah', 'Al-Khobar', 'Dhahran', 'Riyadh',
            'Riyad', 'Jeddah', 'Khobar', 'Dammam', 'Dhahran', 'Jubail','Qatif','Madinah','Meccah'
          ];
          
          // Try to find city boundaries by looking for known city names
          let remainingString = cityData;
          const foundCities = [];
          
          // Sort cities by length (longest first) to avoid partial matches
          const sortedCities = knownCities.sort((a, b) => b.length - a.length);
          
          for (const city of sortedCities) {
            if (remainingString.includes(city)) {
              foundCities.push(city);
              remainingString = remainingString.replace(city, '|'); // Replace with separator
            }
          }
          
          if (foundCities.length > 0) {
            listOfCities = foundCities;
          } else {
            // If no known cities found, try to split by common patterns
            // This is a fallback for unknown formats
            listOfCities = [cityData]; // Treat as single city
          }
        }
      }
    }

    // If no cities specified after parsing, show everywhere
    if (!listOfCities || listOfCities.length === 0) {
      return true;
    }

    // Use global CityMatcher if available, otherwise use simple matching
    if (window.CityMatcher && window.CityMatcher.isAvailableInList) {
      return window.CityMatcher.isAvailableInList(this.currentCity, listOfCities);
    } else {
      // Fallback to case-insensitive comparison
      return listOfCities.some(city => 
        city.toLowerCase().trim() === this.currentCity.toLowerCase().trim()
      );
    }
  }

  /**
   * Check if a product is truly sold out (no inventory) vs just not available in current city
   * @param {Object} product - The product object from ADDONS
   * @returns {boolean} - True if product is truly sold out (no inventory)
   */
  isProductSoldOut(product) {
    // This would need to be implemented based on your inventory tracking
    // For now, we'll assume all products in ADDONS are available for purchase
    // since they're being shown in the addon modal
    return false;
  }

  /**
   * Ensure all addon buttons show "Add to Cart" text and are enabled
   * This overrides any "sold out" status that might be set in the HTML
   */
  ensureAddonButtonsShowATC() {
    if (!this.modal) return;

    this.modal.querySelectorAll(".addon-button.quick-add__submit").forEach((button) => {
      // Remove any disabled state
      button.disabled = false;
      button.removeAttribute('disabled');
      button.removeAttribute('inert');
      button.removeAttribute('aria-disabled');
      
      // Remove any sold out classes
      button.classList.remove('disabled', 'button--disabled');
      
      // Ensure the button shows "Add to Cart" text
      const atcText = button.querySelector('.atc-text');
      if (atcText) {
        atcText.textContent = Shopify.locale === "en" ? "Add to Cart" : "أضف إلى السلة";
      }
      
      // Remove any sold out message spans
      const soldOutMessage = button.querySelector('.sold-out-message');
      if (soldOutMessage) {
        soldOutMessage.classList.add('hidden');
      }
      
      // Ensure the button is clickable
      button.style.pointerEvents = 'auto';
      button.style.cursor = 'pointer';
    });
  }

  setSelectedStateOnProducts() {
    this.modal.querySelectorAll(".addon-button.quick-add__submit").forEach((button) => {
      if (button.classList.contains("added")) {
        button.classList.remove("added");
      }
      const productCard = button.closest(".card-wrapper");
      const quantitySelector = productCard?.querySelector(".addon-modal .addon-product-quantity");
      if (quantitySelector) {
        quantitySelector.style.display = "none";
        // Move quantity selector back to its original position (after price and title)
        const cardContent = productCard.querySelector(".addon-modal .card__content");
        if (cardContent) {
          cardContent.appendChild(quantitySelector);
        }
      }
      
      // Ensure button shows ATC text when not added
      if (!button.classList.contains("added")) {
        const atcText = button.querySelector('.atc-text');
        if (atcText) {
          atcText.textContent = Shopify.locale === "en" ? "Add to Cart" : "أضف إلى السلة";
        }
      }
    });

    this.data.items.forEach((item) => {
      const button = this.modal.querySelector(`.addon-button.quick-add__submit[data-variant-id="${item.id}"]`);
      if (button) {
        button.classList.add("added");
        const productCard = button.closest(".card-wrapper");
        const quantitySelector = productCard?.querySelector(".addon-modal .addon-product-quantity");
        const quantityInput = productCard?.querySelector(".addon-modal__content .quantity__input");

        if (quantitySelector) {
          quantitySelector.style.display = "flex";
          // Move quantity selector back to its original position (after price and title)
          const cardContent = productCard.querySelector(".addon-modal .card__content");
          if (cardContent) {
            cardContent.appendChild(quantitySelector);
          }
        }
        if (quantityInput) quantityInput.value = item.quantity;
      }
    });

    window.latestCartData = document.querySelector("cart-drawer-items")?.latestCartData || document.querySelector("cart-items")?.latestCartData;
    if (window.latestCartData && window.latestCartData.items && window.latestCartData.items.length > 0) {
      // Get the variant IDs that are already in the current session's data.items
      const currentSessionVariantIds = this.data.items.map(item => item.id);
      
      window.latestCartData.items.forEach((item) => {
        // Skip items that are already in the current session to avoid double-processing
        if (currentSessionVariantIds.includes(item.variant_id.toString())) {
          return;
        }
        const button = this.modal.querySelector(`.addon-button.quick-add__submit[data-variant-id="${item.variant_id}"]`);
        if (button) {
          button.classList.add("added");
          const productCard = button.closest(".addon-modal .card-wrapper");
          const quantitySelector = productCard?.querySelector(".addon-modal .addon-product-quantity");
          const quantityInput = productCard?.querySelector(".addon-modal__content .quantity__input");
          if (quantitySelector) {
            quantitySelector.style.display = "flex";
            // Move quantity selector back to its original position (after price and title)
            const cardContent = productCard.querySelector(".addon-modal .card__content");
            if (cardContent) {
              cardContent.appendChild(quantitySelector);
            }
          }
          if (quantityInput) quantityInput.value = item.quantity;
        }
      });
    }
  }

  openModal() {
    this.modalObject = new Modal("addon-products", {
      content: this.createAddonGrid(),
      onClose: () => {
        this.data = {};
        this.data.items = [];
        // Reset summary display when modal closes
        if (this.addonSummaryQuantity) this.addonSummaryQuantity.textContent = "0";
        if (this.addonSummaryPrice) {
          this.addonSummaryPrice.textContent = "0.00";
          this.addonSummaryPrice.setAttribute("data-price-to-convert", "0");
        }
        if (this.addonTotalCart) {
          const parentProductPrice = this.getParentProductPrice();
          const displayPrice = isNaN(parentProductPrice) ? 0 : parentProductPrice;
          this.addonTotalCart.textContent = `QAR ${displayPrice.toFixed(2)}`;
          this.addonTotalCart.setAttribute("data-price-to-convert", displayPrice);
        }
        // Remove outside click listener when modal closes
        this.removeOutsideClickListener();
      },
    });
    this.modal = this.modalObject.xModal.querySelector(".addon-modal");
    this.productGrid = this.modalObject.xModal.querySelector(".grid.product-grid");
    this.addonPrice = this.modalObject.xModal.querySelector("#addOnPrice");
    this.addOnPriceText = this.addonPrice.querySelector("#addOnPriceText");
    this.addOnPriceMoney = this.addonPrice.querySelector("#addOnPriceMoney");

    // Initialize add-on summary elements
    this.addonSummaryQuantity = this.modalObject.xModal.querySelector("#addonSummaryQuantity");
    this.addonSummaryPrice = this.modalObject.xModal.querySelector("#addonSummaryPrice");
    this.addonTotalCart = this.modalObject.xModal.querySelector("#addonTotalCart");

    this.handleErrorMessage();
    this.renderGrid();
    this.data = {};
    this.data.items = [];

    // Initialize summary display
    this.updateAddonSummary();
    
    // Add global click prevention for the modal
    this.addGlobalClickPrevention();
    
    // Setup outside click detection to open cart drawer
    this.setupOutsideClickListener();
  }

  // Setup listener for clicks outside the modal to open cart drawer
  setupOutsideClickListener() {
    if (!this.modalObject || !this.modalObject.xModal) return;
    
    // Get the modal backdrop/overlay
    const modalBackdrop = this.modalObject.xModal.querySelector('[x-modal-overlay]') ||
                         this.modalObject.xModal.querySelector('.modal-overlay') ||
                         this.modalObject.xModal;
    
    // Handler for outside clicks
    this._outsideClickHandler = (event) => {
      
      const clickedElement = event.target;
      const modalContent = this.modal;

    if(clickedElement.closest('.card-product-img-wrap')) {
      const linkEl = clickedElement.closest('.card-product-img-wrap');
      const href = linkEl.getAttribute('href'); // or linkEl.href
      event.preventDefault();
      openZoom(href);
    }
      
      // If click is on backdrop/overlay or outside modal content, open cart drawer
      if (modalContent && !modalContent.contains(clickedElement)) {
        // Only if click is actually on the backdrop, not on modal content
        if (clickedElement === modalBackdrop || 
            clickedElement.closest('[x-modal-overlay]') ||
            (!clickedElement.closest('.addon-modal') && !clickedElement.closest('.modal-content'))) {
          event.preventDefault();
          event.stopPropagation();
          
          // Open cart drawer and close modal
          this.openCartDrawerAndCloseModal();
        }
      }
    };

function openZoom(src) {
  const overlay = document.createElement('div');
  overlay.className = 'image-zoom-overlay';
  overlay.innerHTML = `<button class="zoom-close">x</button><div class="zoom-loader"></div><img src="${src}" style="display:none;" />`;
  const img = overlay.querySelector('img');
  const loader = overlay.querySelector('.zoom-loader');
  img.onload = () => {
    loader.style.display = 'none';
    img.style.display = 'block';
  };
  img.onerror = () => {
    loader.innerText = 'Failed to load image';
  };
  overlay.addEventListener('click', () => overlay.remove());
  document.body.appendChild(overlay);
}
    
    // Add click listener to backdrop
    if (modalBackdrop) {
      modalBackdrop.addEventListener('click', this._outsideClickHandler, true);
      this._outsideClickElement = modalBackdrop;
    }
  }

  // Remove outside click listener
  removeOutsideClickListener() {
    if (this._outsideClickHandler && this._outsideClickElement) {
      this._outsideClickElement.removeEventListener('click', this._outsideClickHandler, true);
      this._outsideClickHandler = null;
      this._outsideClickElement = null;
    }
  }

  // Open cart drawer and close modal (for outside click and X button)
  openCartDrawerAndCloseModal() {
    // Get cart drawer element
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      console.error('Cart drawer element not found');
      // Still close modal even if cart drawer not found
      if (this.modalObject && this.modalObject.close) {
        this.modalObject.close();
      }
      return;
    }
    
    // Use productForm's refreshAndOpenCartDrawer method to ensure items show up
    if (this.productForm && this.productForm.refreshAndOpenCartDrawer) {
      this.productForm.refreshAndOpenCartDrawer();
    } else {
      // Fallback: refresh cart drawer manually
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      const cartUrl = (typeof routes !== 'undefined' && routes.cart_url) ? routes.cart_url : 
                     (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) ? window.Shopify.routes.cart_url :
                     `${window.Shopify.routes.root}cart`;
      
      fetch(`${cartUrl}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          
          if (cartDrawerItems) {
            const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
            selectors.forEach(selector => {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                const clonedSource = sourceElement.cloneNode(true);
                targetElement.replaceWith(clonedSource);
              }
            });
          }
          
          // Open cart drawer
          if (cartDrawer.renderContents) {
            const freshCartDrawer = html.querySelector('#cart-drawer') || html.querySelector('cart-drawer');
            const sectionsData = {};
            if (freshCartDrawer) {
              sectionsData['cart-drawer'] = freshCartDrawer.outerHTML;
            }
            cartDrawer.renderContents({ sections: sectionsData });
          } else if (cartDrawer.open) {
            cartDrawer.open();
          }
        })
        .catch(error => {
          console.error('Error opening cart drawer:', error);
          if (cartDrawer && cartDrawer.open) {
            cartDrawer.open();
          }
        });
    }
    
    // Close modal after a short delay to allow drawer to start opening
    setTimeout(() => {
      if (this.modalObject && this.modalObject.close) {
        this.modalObject.close();
      }
    }, 300);
  }

  attachEventListeners() {
    this.tabs = this.modal.querySelectorAll(".addon-modal__tab-container button");
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", (event) => {
        this.tabs.forEach((tab) => tab.classList.remove("active"));
        event.currentTarget.classList.add("active");
        this.renderGrid(event.currentTarget.dataset.id);
      });
    });
  }

  showLoader() {
    // Create loader element if it doesn't exist
    if (!this.loaderElement) {
      this.loaderElement = document.createElement("div");
      this.loaderElement.className = "loader";
      this.loaderElement.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(255, 255, 255, 0.5);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
      `;
      document.body.appendChild(this.loaderElement);
    }

    // Show the loader
    this.loaderElement.style.display = "flex";
  }

  hideLoader() {
    // Hide the loader
    if (this.loaderElement) {
      this.loaderElement.style.display = "none";
    }
  }

  // Method to prevent card clicks
  preventCardClicks() {
    // Prevent clicking on product cards (except addon buttons and quantity controls)
    this.modal.querySelectorAll(".card-wrapper").forEach((card) => {
      // Remove any existing click handlers to avoid duplicates
      card.removeEventListener("click", this.handleCardClick);
      
      // Add the click prevention handler
      card.addEventListener("click", this.handleCardClick.bind(this));
    });

    // Prevent clicking on product title and media links
    this.modal.querySelectorAll(".card__heading a, .card__media a").forEach((link) => {
      // Remove any existing click handlers to avoid duplicates
      link.removeEventListener("click", this.handleLinkClick);
      
      // Add the click prevention handler
      link.addEventListener("click", this.handleLinkClick.bind(this));
    });
  }

  // Handler for card clicks
  handleCardClick(event) {
    // Allow clicks on addon buttons and quantity controls
    if (event.target.closest(".addon-button") || 
        event.target.closest(".quantity__button") || 
        event.target.closest(".quantity__input")) {
      return; // Allow these clicks to proceed
    }
    
    // Prevent all other clicks on the card
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  // Handler for link clicks
  handleLinkClick(event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  // Add global click prevention for the modal
  addGlobalClickPrevention() {
    // Use event delegation on the modal to catch all clicks
    this.modal.addEventListener("click", (event) => {
      // Allow clicks on functional elements
      if (event.target.closest(".addon-button") || 
          event.target.closest(".quantity__button") || 
          event.target.closest(".quantity__input") ||
          event.target.closest(".addon-modal__tab-container") ||
          event.target.closest(".close-button") ||
          event.target.closest("#continueToCart")) {
        return; // Allow these clicks to proceed
      }
      
      // Prevent clicks on product cards, titles, and media
      if (event.target.closest(".card-wrapper") || 
          event.target.closest(".card__heading a") || 
          event.target.closest(".card__media a")) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    }, true); // Use capture phase to catch events early
  }

  addToCartEventListener() {
    this.modal.querySelectorAll(".addon-button.quick-add__submit").forEach((button) => {
      button?.addEventListener("click", (event) => {
        event.preventDefault();
        const productCard = event.currentTarget.closest(".card-wrapper");
        const quantitySelector = productCard?.querySelector(".addon-modal .addon-product-quantity");

        event.currentTarget.classList.add("added");
        if (quantitySelector) {
          const quantityInput = quantitySelector.querySelector(".addon-modal .quantity__input");
          if (quantityInput && parseInt(quantityInput.value) === 0) {
            quantityInput.value = 1;
          }
          quantitySelector.style.display = "flex";
          const cardContent = productCard.querySelector(".addon-modal .card__content");
          if (cardContent) {
            cardContent.appendChild(quantitySelector);
          }
        }

        this.createFormData(event.currentTarget.dataset);
      });
    });

    // Handle quantity changes
    this.modal.querySelectorAll(".addon-modal__content .quantity__input").forEach((input) => {
      input?.addEventListener("change", (event) => {
        const productCard = event.target.closest(".addon-modal .card-wrapper");
        const addButton = productCard?.querySelector(".addon-modal .addon-button");
        if (addButton) {
          let quantity = parseInt(event.target.value) || 1;

          // Ensure quantity is never below 1
          if (quantity < 1) {
            quantity = 1;
            event.target.value = 1;
          }

          // Clear any error messages
          this.handleErrorMessage();

          this.createFormData(addButton.dataset);
        }
      });
    });

    this.modal.querySelectorAll(".addon-modal .quantity__button").forEach((button) => {
      // Remove any existing event listeners to prevent duplicates
      button.removeEventListener("click", this.handleQuantityButtonClick);
      
      // Add a data attribute to mark this button as handled
      button.setAttribute('data-addon-handled', 'true');
      
      // Add the event listener with capture to handle it first
      button.addEventListener("click", this.handleQuantityButtonClick.bind(this), true);
    });
  }

  handleQuantityButtonClick(event) {
    // Prevent multiple executions
    if (event.target.getAttribute('data-processing') === 'true') {
      return;
    }
    
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    // Mark as processing to prevent multiple executions
    event.target.setAttribute('data-processing', 'true');
    
    const productCard = event.target.closest(".addon-modal .card-wrapper");
    const addButton = productCard?.querySelector(".addon-modal .addon-button");
    const quantityInput = productCard?.querySelector(".addon-modal .quantity__input");

    if (addButton && quantityInput) {
      const currentQuantity = parseInt(quantityInput.value) || 1;
      let newQuantity = currentQuantity;

      if (event.target.name === "plus") {
        // Increase quantity by 1
        newQuantity = currentQuantity + 1;
        quantityInput.value = newQuantity;
        this.handleErrorMessage(); // Clear any previous errors
      } else if (event.target.name === "minus") {
        if (currentQuantity <= 1) {
          // Reset to Add button state
          addButton.classList.remove("added");
          const quantitySelector = productCard.querySelector(".addon-modal .addon-product-quantity");
          if (quantitySelector) {
            quantitySelector.style.display = "none";
          }

          // Remove product from selection
          const variantId = addButton.dataset.variantId;
          this.removeAddonItem(variantId);

          // Update price display
          const totalPrice = this.calculateTotalPrice();
          this.addOnPriceText.textContent = Shopify.locale === "en" ? "Add-ons Total Price:" : "السعر الإجمالي للإضافات:";
          this.addOnPriceMoney.textContent = `QAR ${totalPrice.toFixed(2)}`;
          this.addOnPriceMoney.setAttribute("data-price-to-convert", totalPrice);

          if (typeof initialCurrencyChange === "function") initialCurrencyChange();
          
          // Reset processing flag
          setTimeout(() => {
            event.target.removeAttribute('data-processing');
          }, 100);
          return; // Don't update form data if removing item
        } else {
          // Decrease quantity by 1
          newQuantity = currentQuantity - 1;
          quantityInput.value = newQuantity;
        }
      }

      // Update form data after quantity change
      this.createFormData(addButton.dataset);
    }
    
    // Reset processing flag after a short delay
    setTimeout(() => {
      event.target.removeAttribute('data-processing');
    }, 100);
  }

  continueToCartEventListener() {
    const self = this;
    
    function addToCart(event) {
      event.preventDefault();
      
      // Check if this is X button click
      const isCloseButton = event.target.closest('.close-button.modal-close') || 
                           event.target.closest('.addonClose') ||
                           event.currentTarget.classList.contains('close-button') ||
                           event.currentTarget.classList.contains('addonClose');
      
      // If X button is clicked (with or without addons), open cart drawer and close modal
      if (isCloseButton) {
        // Open cart drawer and close modal
        self.openCartDrawerAndCloseModal();
        return;
      }
      
      // Prevent multiple rapid clicks
      if (this.isSubmitting) {
        return;
      }
      
      this.isSubmitting = true;
      const continueButton = this.modal.querySelector("#continueToCart");
      const closeButton = this.modal.querySelector(".close-button.modal-close");
      
      // Immediately disable buttons and show loading state
      if (continueButton) {
        continueButton.disabled = true;
        continueButton.style.opacity = '0.6';
        continueButton.style.pointerEvents = 'none';
        continueButton.inert = true;
      }
      if (closeButton) {
        closeButton.classList.add("loading");
      }
      
      // If no addons selected, just open cart drawer and close modal
      if (!this.data.items || this.data.items.length === 0) {
        this.openCartDrawerAndCloseModal();
        setTimeout(() => {
          this.isSubmitting = false;
          if (continueButton) {
            continueButton.inert = false;
            continueButton.disabled = false;
            continueButton.style.opacity = '1';
            continueButton.style.pointerEvents = 'auto';
          }
          if (closeButton) {
            closeButton.classList.remove("loading");
          }
        }, 1000);
        return;
      }
      
      // Addons selected - add them to cart and open drawer
      this.productForm
        .handleAddons(this.data, event)
        .then((response) => {
          if (response && response.items) {
            // Cart items added successfully
          }
          if (response && response.errors) {
            this.handleErrorMessage(response.errors[0].message);
          } else {
            this.handleErrorMessage();
          }
          
          // Close modal after cart drawer has started opening
          // Cart drawer opening is handled in handleAddons -> refreshAndOpenCartDrawer
          setTimeout(() => {
            if (this.modalObject && this.modalObject.xModal) {
              this.modalObject.close();
            }
          }, 500);
        })
        .catch((error) => {
          this.handleErrorMessage(error.message);
          // Still open cart drawer even on error
          this.openCartDrawerAndCloseModal();
        })
        .finally(() => {
          // Reset the submission flag after a delay
          setTimeout(() => {
            this.isSubmitting = false;
            const continueButton = this.modal.querySelector("#continueToCart");
            const closeButton = this.modal.querySelector(".close-button.modal-close");
            
            // Re-enable buttons
            if (continueButton) {
              continueButton.inert = false;
              continueButton.disabled = false;
              continueButton.style.opacity = '1';
              continueButton.style.pointerEvents = 'auto';
            }
            if (closeButton) {
              closeButton.classList.remove("loading");
            }
          }, 2000);
        });
    }

    // Attach event listeners
    const continueButton = this.modal.querySelector("#continueToCart");
    const closeButton = this.modal.querySelector(".close-button.modal-close") || 
                       this.modal.querySelector(".addonClose");
    
    if (continueButton) {
      continueButton.addEventListener("click", addToCart.bind(this));
    }
    
    if (closeButton) {
      closeButton.addEventListener("click", addToCart.bind(this));
    }
  }

  createFormData(productDataset) {
    const productCard = document.querySelector(`.addon-button[data-variant-id="${productDataset.variantId}"]`)?.closest(".card-wrapper");
    const quantityInput = productCard?.querySelector(".addon-modal__content .quantity__input");
    let quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    // Ensure quantity is never negative
    quantity = Math.max(1, quantity);

    // Update the input value if it was negative
    if (quantityInput && parseInt(quantityInput.value) !== quantity) {
      quantityInput.value = quantity;
    }

    let product = {};
    product.id = productDataset.variantId;
    product.quantity = quantity;

    // Initialize properties object
    product.properties = {};

    // Add all properties for addon product
    product.properties["_AddOnProduct"] = "AddOnProduct";
    product.properties["_parent_id"] = this.productForm.querySelector('[name="id"]').value || "null";
    product.properties["_product_image"] = productDataset.productImage || "null";
    product.properties["_city"] = this.convertToEnglishCity(this.productForm.dataset.city || "Riyadh");
    product.properties["_arabicCountrySelected"] = this.productForm.dataset.arabicCity || "الرياض";
    product.properties["_product_handle"] = productDataset.productHandle || "null";
    product.properties["_product_description"] = productDataset.productDescription || "null";
    product.properties["_product_title"] = productDataset.productTitle || "null";
    product.properties["_product_id"] = productDataset.productId || "null";
    product.properties["_price"] = productDataset.productPrice || "null";
    product.properties["_product_categories"] = productDataset.productCategories || "null";
    product.properties["_brand_name"] = productDataset.brandName || "null";
    product.properties["_product_type"] = productDataset.productType || "null";

    // Check if product already exists in items array
    const existingProductIndex = this.data.items.findIndex((item) => item.id === product.id);
    if (existingProductIndex === -1) {
      this.data.items.push(product);
    } else {
      this.data.items[existingProductIndex] = product;
    }

    // Update price display
    const totalPrice = this.calculateTotalPrice();

    this.addOnPriceText.textContent = Shopify.locale === "en" ? "Add-ons Total Price:" : "السعر الإجمالي للإضافات:";
    this.addOnPriceMoney.textContent = `QAR ${totalPrice.toFixed(2)}`;
    this.addOnPriceMoney.setAttribute("data-price-to-convert", totalPrice);

    // Update add-on summary
    this.safeUpdateSummary();

    if (typeof initialCurrencyChange === "function") initialCurrencyChange();
  }

  handleErrorMessage(errorMessage = false) {
    const errorElement = this.modal.querySelector("#errorMessage");
    if (errorElement) {
      errorElement.textContent = !errorMessage ? "" : errorMessage;
    }
  }
}

// Initialize the addon modal
new AddonProductModal();

// Test function for city filtering (can be called from browser console)
window.testAddonCityFiltering = function() {
  
  // Find the addon modal instance
  const addonModal = document.querySelector('#AddonProductModalOpener');
  if (!addonModal) {
    return;
  }
  
  // Get current city
  const currentCity = localStorage.getItem('city_value') || localStorage.getItem('city') || 'Riyadh';
  
  // Check if ADDONS data exists
  if (typeof ADDONS === 'undefined' || !Array.isArray(ADDONS)) {
    return;
  }
  
  
  // Test city filtering for each category
  ADDONS.forEach((category, categoryIndex) => {
    
    // Check first few products for city data
    category.products.slice(0, 3).forEach((product, productIndex) => {
      // Product data logging removed for production
    });
  });
  
  return {
    currentCity: currentCity,
    addonCategories: ADDONS.length,
    totalProducts: ADDONS.reduce((total, category) => total + category.products.length, 0)
  };
};

// Test function to check city data structure
window.debugAddonCityData = function() {
  if (typeof ADDONS === 'undefined' || !Array.isArray(ADDONS)) {
    return;
  }
  
  const currentCity = localStorage.getItem('city_value') || localStorage.getItem('city') || 'Riyadh';
  
  // Check first category's first few products
  const firstCategory = ADDONS[0];
  if (firstCategory && firstCategory.products) {
    // Category and product data logging removed for production
  }
  
  return {
    currentCity: currentCity,
    firstCategoryName: firstCategory ? firstCategory.name : 'None',
    firstCategoryProductCount: firstCategory ? firstCategory.products.length : 0
  };
};
